<template>
    <div class="dafault-container">
        <div class="m-3">
            <h4><strong>Conciliação Bancária</strong></h4>
            <span>Vincule lançamentos aos extratos</span>
        </div>
        <div class="row bg-light border p-2 m-2" v-for="item in extrato" :key="item.id">
            <div class="col-md-3 d-flex flex-column justify-content-center align-items-start">
                <span>Data: {{ item.data }}</span>
                <span>Valor: {{ item.valor }}</span>
                <span>Saldo: {{ item.saldo.toFixed(2) }}</span>
                <span>Descrição: {{ item.descricao ? item.descricao : 'Sem Descrição' }}</span>
            </div>
            <div class="col-md-3 d-flex align-items-center" v-if="!item.conciliado">
                <div class="lancamentos-select">
                    <form-field v-model="item.lancamento" type="select" label="Selecione um lançamento" :select-options="lanOpts"></form-field>
                </div>
                <div class="acoes">
                    <button class="btn btn-success ml-2" title="Vincular Lançamento" @click="vincularLancamento"><i class="fa fa-link"></i></button>
                </div>
            </div>
            <div class="col-md-6 d-flex">
                <div class="row border border-success rounded bg-success text-white p-2 ml-1 mr-1" v-for="lancamento in item.lancamentos" :key="lancamento.id">
                    <div class="d-flex flex-column align-items-start ml-2 mr-2">
                        <small>Data: {{ lancamento.data }}</small>
                        <small>Valor: {{ lancamento.valor }}</small>
                        <small>Nome: {{ lancamento.nome }}</small>
                        <small>Saldo: {{ lancamento.saldo.toFixed(2) }}</small>
                    </div>
                    <div class="btn-excluir" title="Desvincular Lançamento" @click="desvincularLancamento(item.codextrato, lancamento.codfin)">
                        <i class="fa fa-close"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            extrato: [
                { codextrato: 1, data: '18/02/2022', valor: 88.88, saldo: 88.88, historico: [], conciliado: false, lancamentos: [] },
                { codextrato: 2, data: '18/02/2022', valor: 99.99, saldo: 99.99, historico: [], conciliado: false, lancamentos: [] },
                { codextrato: 3, data: '18/02/2022', valor: 100.00, saldo: 100.00, historico: [], conciliado: false, lancamentos: [] },
                { codextrato: 4, data: '18/02/2022', valor: 100.00, saldo: 100.00, historico: [], conciliado: false, lancamentos: [] },
            ],
            lancamentos: [
                { codfin: 1, data: '18/02/2022', valor: 44.44, nome: 'Lanc 01', descricao: null, saldo: 44.44, conciliado: false, },
                { codfin: 2, data: '18/02/2022', valor: 44.44, nome: 'Lanc 02', descricao: null, saldo: 44.44, conciliado: false, },
                { codfin: 3, data: '18/02/2022', valor: 99.99, nome: 'Lanc 03', descricao: null, saldo: 99.99, conciliado: false, },
                { codfin: 4, data: '18/02/2022', valor: 200.00, nome: 'Lanc 04', descricao: null, saldo: 200.00, conciliado: false, },
            ],
        }
    },
    computed: {
        lanOpts() {
            const lansNaovinculados = this.lancamentos.filter(lan => {
                return lan.conciliado === false
            })

            const lanOpts = lansNaovinculados.map(lan => {
                return { id: lan.codfin, text: `Nome: ${lan.nome}, Data: ${lan.data}, Valor: ${lan.valor}` }
            })

            return lanOpts
        },
    },
    methods: {        
        vincularLancamento() {
            this.extrato.map(item => {
                if (item.lancamento) {
                    this.lancamentos.map(lan => {
                        if (lan.codfin == item.lancamento) {
                            item.lancamentos.push(lan)

                            if (item.saldo >= lan.saldo) {
                                item.saldo = item.saldo - lan.saldo
                                let valor = lan.saldo
                                item.historico.push({
                                    id: lan.codfin,
                                    valor: valor
                                })
                            } else {
                                let valor = lan.saldo - (lan.saldo - item.saldo)
                                item.historico.push({
                                    id: lan.codfin,
                                    valor: valor
                                })
                                item.saldo = item.saldo - lan.saldo
                            }
                            
                            if (item.saldo < lan.saldo)
                                lan.saldo = item.saldo * -1
                            else
                                lan.saldo = lan.saldo - ((item.saldo + lan.saldo) - item.saldo)

                            if (lan.saldo <= 0) {
                                lan.saldo = 0
                                lan.conciliado = true
                            }

                            if (item.saldo <= 0) {
                                item.saldo = 0
                                item.conciliado = true
                            }

                            delete item.lancamento
                        }
                    })
                }
            })
        },
        desvincularLancamento(extId, lanId) {
            this.restaurarValor(extId, lanId)

            const extrato = this.extrato.filter(obj => {
                return obj.codextrato == extId
            })

            const lancamentos = extrato[0].lancamentos.filter(lan => {
                return lan.codfin != lanId
            })

            this.extrato.map(item => {
                if (item.codextrato == extId) {
                    item.lancamentos = lancamentos
                }
            })
        },
        restaurarValor(extId, lanId) {
            const extrato = this.extrato.filter(obj => {
                return obj.codextrato == extId
            })

            extrato[0].historico.map(h => {
                if (h.id == lanId) {
                    this.lancamentos.map(lan => {
                        if (lan.codfin == lanId) {
                            lan.saldo = lan.saldo + h.valor
                            if (lan.saldo > 0) {
                                lan.conciliado = false
                            }
                        }
                    })
                    this.extrato.map(e => {
                        if (e.codextrato == extId) {
                            e.saldo = e.saldo + h.valor
                            if (e.saldo > 0) {
                                e.conciliado = false
                            }
                        }
                    })
                }
            })
        }
    },
}   
</script>

<style>
    .btn-excluir {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: .75rem;
        width: 20px;
        height: 20px;
        border-radius: 100%;
        margin-top: -5px;
        margin-right: -5px;
        z-index: 1;
        background-color: green;
        opacity: 70%;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/forms/conciliacao-form.vue